<script>

export let name = "checkmark.circle.fill"
export let margin = "0px"
export let padding = "0px"
export let width = "24px"
export let height = "24px"
export let color = "#A9B2C0"
export let opacity = 1.0

if (color == "primary") {
    color = "#75FFF1"
}

</script>

<div class="icon" style="
    background-color: {color};
    width: {width};
    height: {height};
    padding: {padding};
    margin: {margin};
    opacity: {opacity};
    -webkit-mask: url(../static/symbols/{name}.svg) no-repeat center;
    -mask: url(../static/symbols/{name}.svg) no-repeat center;
    mask-size: contain;
    -webkit-mask-size: contain;
">


</div>


<style>


</style>